export const environment = {
  isIntranet: 'false',
  disableRouteGuards: 'true',
  production: false,
  ENV_ACTIVE_PROFILE: 'customIDP',
  ON_CUSTOMIDP: 'customIDP',
  DefaultCountry: 'SGP',
  RESOURCE_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/home',
  isCloudEnv: 'false',
  version: '1.1.8',
  
  // Group PLAID
  BRAND_LANDING_URL: 'https://pruworks-preprod.prudential.co.id/',
  
  // PnC Service
  USER_SERVICE: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/users', //API-USERROLE
  QUOTE_SERVICE: 'https://pruworks-preprod.prudential.co.id/api/pnc/quotes',
  API_ROLE_PNC_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/users', //API-USERROLE
  // Pnc anonymous user
  userName: '',
  password: '',

  //LIFE anonymous user
  userNameLife: '',
  passwordLife: '',

  // domain
  WEB_DOMAIN: '.pruworks-preprod.prudential.co.id',
  PATH: '/pnc-claims-portal',

  // API CONFIG URL PNC
  API_LOB_ONPREM_PNC: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/roles/',
  CUSTOMER_SELF_CONTEXT_PATH: '/pnc-self-portal',
  // Pnc context path
  CONTEXT_PATH: '/pnc-customer-portal',
  API_USER_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/customer-api', //API-CUSTOMERPORTAL
  API_ROLE_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/roles/user', //API-USERROLE
  API_LOB_PERSON_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/roles/', //API-USERROLE
  API_LOGIN_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service/', //API-USERROLE
  API_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/customer-api', //API-CUSTOMERPORTAL
  API_CONFIG_URL: 'https://pruworks-preprod.prudential.co.id/api/group-common', //COMMON-CONFIGURATION
  API_DMS_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/api/life/dms', //API-DMS
  API_SERVER_USER: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service', //API-USERROLE
  API_CONFIG_COMMON: 'https://pruworks-preprod.prudential.co.id/api/group-common/configuration/',
  EnterpriseLinkKey: 'EnterpriseLink',

  //GROUP Service
  API_GROUP_USERROLE_SERVICE: 'https://pruworks-preprod.prudential.co.id/api/life/userrole-service', //API-USERROLE
  //redirect URI for all portals
  localOrigin: 'https://pruworks-preprod.prudential.co.id',
  onlineClaim: 'https://pruworks-preprod.prudential.co.id',
  N_GS: 'https://pruworks-preprod.prudential.co.id',
  N_GU: 'https://pruworks-preprod.prudential.co.id',
  L_CS: 'https://pruworks-preprod.prudential.co.id',
  L_SI: 'https://pruworks-preprod.prudential.co.id',
  L_UW: 'https://pruworks-preprod.prudential.co.id',
  L_MP: 'https://pruworks-preprod.prudential.co.id',
  L_LM: 'https://pruworks-preprod.prudential.co.id',
  L_DM: 'https://pruworks-preprod.prudential.co.id',
  L_PS: 'https://pruworks-preprod.prudential.co.id',
  L_CR: 'https://pruworks-preprod.prudential.co.id',
  L_CO: 'https://pruworks-preprod.prudential.co.id',
  L_DPS: 'https://pruworks-preprod.prudential.co.id',
  A_AD: 'https://pruworks-preprod.prudential.co.id',
  L_DS: 'https://pruworks-preprod.prudential.co.id',
  P_SI: 'https://pruworks-preprod.prudential.co.id',
  P_CO: 'https://pruworks-preprod.prudential.co.id',
  P_CS: 'https://pruworks-preprod.prudential.co.id',
  P_CC: 'https://pruworks-preprod.prudential.co.id',
  P_SV: 'https://pruworks-preprod.prudential.co.id',
  P_GP: 'https://pruworks-preprod.prudential.co.id',
  P_SB: 'https://pruworks-preprod.prudential.co.id',
  G_HR: 'https://pruworks-preprod.prudential.co.id',
  P_UW: 'https://pruworks-preprod.prudential.co.id',
  G_FI: 'https://pruworks-preprod.prudential.co.id',
  G_ME: 'https://pruworks-preprod.prudential.co.id',
  G_PB: 'https://pruworks-preprod.prudential.co.id',
  G_PA: 'https://pruworks-preprod.prudential.co.id',
  G_PO: 'https://pruworks-preprod.prudential.co.id',
  G_PH: 'https://pruworks-preprod.prudential.co.id',
  G_PC: 'https://pruworks-preprod.prudential.co.id',
  G_PP: 'https://pruworks-preprod.prudential.co.id',
  G_PT: 'https://pruworks-preprod.prudential.co.id',
  G_IU: 'https://pruworks-preprod.prudential.co.id',
  G_OP: 'https://pruworks-preprod.prudential.co.id',
  G_SL: 'https://pruworks-preprod.prudential.co.id',
  G_IP: 'https://pruworks-preprod.prudential.co.id',
  G_IC: 'https://pruworks-preprod.prudential.co.id',
  G_IA: 'https://pruworks-preprod.prudential.co.id',
  G_IF: 'https://pruworks-preprod.prudential.co.id',
  G_IR: 'https://pruworks-preprod.prudential.co.id',
  G_DH: 'https://pruworks-preprod.prudential.co.id',
  L_CL: 'https://pruworks-preprod.prudential.co.id',
  L_CF: 'https://pruworks-preprod.prudential.co.id',


  // ON_PREMISES
  ON_PREMISES: 'onPremise',

  // ON_PREMISES_CAS
  ON_PREMISES_CAS: 'CAS',

  // ON_CLOUD
  ON_CLOUD: 'cloud',

  //Date Format
  DATE_FORMAT: 'DD/MM/YYYY',
  DATE_FORMAT1: 'YYYY-MM-DD',

  // Employee Auth API
  EMPLOYEE_AUTH: {
    baseUrl: 'https://pruworks-preprod.prudential.co.id',
    loginPath: '/customidp/employee/login',
    signupPath: '/customidp/employee/signup',
    forgotPasswordPath: '/customidp/employee/forgot-password'
  },
  
    // Employer Auth API
  EMPLOYER_AUTH: {
    baseUrl: 'https://pruworks-preprod.prudential.co.id',
    loginPath: '/customidp/employee/login',
    signupPath: '/customidp/employee/signup',
    forgotPasswordPath: '/customidp/employee/forgot-password'
  },
  
  
  // Show Portal 2.0
  PORTAL_2_TOGGLE: {
    salesforce: 'true',
    employer: 'true',
    employee: 'true',
  },
  
  // Sales Auth API
  SALESFORCE_AUTH: {
    baseUrl: 'https://pruworks-preprod.prudential.co.id',
    saleLoginPath: '/customidp/sale/login',
    userLoginPath: '/customidp/uw/login',
    salesforceRedirectUrl: 'https://pruworks-preprod.prudential.co.id/GroupSales/proposal/proposal-dashboard',
    underwritingRedirectUrl: 'https://pruworks-preprod.prudential.co.id/GroupUnderwriting/proposal/proposal-dashboard',
    adminPortalRedirectUrl: 'https://pruworks-preprod.prudential.co.id/UserManagement',
    extLoginUrl: '/home/customidp/salesforce/login',
  },

  // Homelanding redirect
  LandingPortalLoginUrl: {
    Employee: 'https://pruworks-preprod.prudential.co.id/home/employee/account/login',
    Employer: 'https://pruworks-preprod.prudential.co.id/home/employer/account/login',
    },
  ON_CUSTOMIDP_TERMS_CONDITIONS_URL: {
    EMPLOYEE: 'https://pruworks-preprod.prudential.co.id/home/terms-and-conditions-employee-id',
    EMPLOYER: 'https://pruworks-preprod.prudential.co.id/home/terms-and-conditions-employer-id',
  },

  // callback urls
  PORTAL_URLS: {
    salesforce: 'https://pruworks-preprod.prudential.co.id/salesforce',
    employer: 'https://pruworks-preprod.prudential.co.id/employer',
    employee: 'https://pruworks-preprod.prudential.co.id/employee',
  },


  
  // CustomerIDP profile
  ON_CUSTOMIDP_Auth: {
    ClientId: '3m751nfhlg4cph831e23e8gsj4',
    //LoginUrl: '${SOE_CUSTOMER_IDP_URL}/group/customidp/oauth2/authorize',
    LoginUrl: 'https://pruworks-preprod.prudential.co.id/customidp/user/login', //customIDP url customized for PLAI
    TokenUrl: 'https://pruworks-preprod.prudential.co.id/oauth2/token',
    redirectUri:
      window.location.origin + '/GroupSales/proposal/proposal-dashboard',
    logoutURL: 'https://pruworks-preprod.prudential.co.id/logout',
    landingLogout: 'https://pruworks-preprod.prudential.co.id/customidp/user-persona',
    response_type: 'code',
    scope: 'read',
    x_api_key: '',
    employerPortal: 'https://pruworks-preprod.prudential.co.id/CustomerPortal/home'
  },

  // IDP-Configuration profile
  IDP: {
    issuer: '/oauth2/default',
    redirectUri: window.location.origin + '/web',
    clientId: '',
    disablePKCE: false,
    responseType: 'code'
  },

  //CAS profile
  OAUTH2_CAS: {
    ClientId: '',
    LoginUrl: 'https://pruworks-preprod.prudential.co.id/cas/oauth2.0/authorize',
    TokenUrl: 'https://pruworks-preprod.prudential.co.id/cas/oauth2.0/accessToken',
    CallbackUrl: window.location.origin + '/home/el-web',
    logoutURL: 'https://pruworks-preprod.prudential.co.id/cas/logout',
    landingLogout: 'https://pruworks-preprod.prudential.co.id/home/user-persona'
  },
  
  PNC_DEFAULT_CUSTOMER_CONFIGURATION: {
    SERVER_URL: '',
    client_id: '',
    redirectUri: window.location.origin + '/home/el-web',
    scope: 'openid',
    response_type: 'code',
    x_api_key: ''
  },

  COGNITO: {
    CAS_SERVER_URL: 'https://pruworks-preprod.prudential.co.id/cas/logout',
    ClientId: '',
    LoginUrl: '/oauth2/authorize',
    TokenUrl: '/oauth2/token',
    UserInfo: '/oauth2/userInfo',
    SERVER_URL: '/logout',
    logoutURL: '/logout',
    landingLogout: 'https://pruworks-preprod.prudential.co.id/home/EL-LandingPage',
    CallbackUrl: window.location.origin + '/home/el-web',
    x_api_key: '',
    identity_provider: ''
  },
};
